export default {
  // 各种推广页访问、按钮点击等统计
  addChannelStatistics(params) {
    return app.http.ajax({
      method: 'post',
      url: '/csface-server/channelStatistics/addChannelStatistics',
      params: params,
    });
  },
};
